import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Photography & Videography",
        crumb: "Photography & Videography"
    }
}